module.exports = __webpack_public_path__ + "20-filled-97754638de238138977d18f7146abd1f.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/step-number-icons/filled/20-filled.svg
// module id = 111
// module chunks = 0